<p>site-delete works!</p>
